import axios from './index'
import prefix_ms from './prefix'

// /youDaoDict/word
// 查询单词
export const postWord = (params) => {
    return axios.request({
      url: prefix_ms + `/youDaoDict/word`,
      method: 'post',
      data: params,
    })
  }
  
  

// 获取用户的生词列表
export const getWordListWord = (params) => {
    return axios.request({
      url: prefix_ms + `/userNewWord/list/word`,
      method: 'get',
      params: params
    })
  }
  
  // /userUnfamiliarWord/word/add
  // 加入生词本
  export const postAddWord = (params) => {
    return axios.request({
      url: prefix_ms + `/userNewWord/add`,
      method: 'post',
      data: params,
    })
  }
  
  
  // /v2/userNewWord/remove/{userWordId}
  // 移出生词本
  export const postRemoveWord = (userWordId) => {
    return axios.request({
      url: prefix_ms + `/userNewWord/remove/${userWordId}`,
      method: 'post',
    })
  }

 // /v2/userNewWord/remove/{userWordId}
  // 移出生词本
  export const postRecoverWord = (userNewWordId) => {
    return axios.request({
      url: prefix_ms + `/userNewWord/recover/${userNewWordId}`,
      method: 'post',
    })
  }


//////////////////
// WEBPACK FOOTER
// ./app/api/vocab.js
// module id = null
// module chunks = 